import React from 'react';
import {BtnText} from 'components/btns';

const MediaContents = (props) => {
  return (
    <div className="MediaContents">
      <div className="con">
        <ul className="wrap-media">
          {props.items.map(media=> {
            return  <li key = {media.id} className="list-media">
                      <div className="wrap-img" style = {{backgroundImage : `url(${media.imageUrl})`}}>
                      </div>
                      <div className="wrap-text">
                        <h3 className="title">{media.title}</h3>
                        <p className="caption">{media.date} {media.source}</p>
                        <p className="text">{media.text}</p>
                      </div>
                      <BtnText text = "기사 원문 링크" className="border" to ={media.url}/>
                    </li>
          })}
        </ul>
      </div>
    </div>
  );
}

export default MediaContents;